import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initRum } from '@/lib/rum';
import { initOutbox } from '@/services/offline/outbox';
import { initPreloadErrorHandler } from '@/utils/preloadError';
import '@/globals.css';

// Inicializa CloudWatch RUM com allowCookies: false (LGPD #378).
// A plataforma (#375) é detectada dentro do initRum().
initRum();

// Recarrega a página quando um chunk lazy falha (rede instável ou deploy novo
// com index.html velho em cache). Antes do render: o erro pode vir do próprio
// import() da primeira rota.
initPreloadErrorHandler();

// Inicia a fila de escritas offline: registra o replay no evento 'online' e
// tenta sincronizar pendências no boot.
initOutbox();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
